export const MidAtlanticPracticeID = '1232';
export const OptimalCarePracticeID = '1245';
